import { Colors } from '../consts/Colors.js';
import AbstractScene from './AbstractScene.js';
import { Sizes } from '../consts/Sizes.js';
import endMissionData from '../data/End.js';

// Prefas
import WhiteRoundedRectangle from '../prefabs/WhiteRoundedRectangle.js';
import ButtonRounded from '../prefabs/ButtonRounded.js';

export default class End extends AbstractScene {
    constructor() {
        super({
            key: 'End',
        });
    }
    init(data) {
        this._init(data);
    }

    preload() {
        this._preload();
        this.videoKey = this.getText('End', 'videoKey1');
        this.videoKey = 'crabeBleuVideo';
        this.preTarget = () => this.scene.start('Mission4');
        this.postTarget = () => {
            this.isPlaying = false;
            this.video.destroy();
            this.startButton.destroy();
            this.allControls.forEach((control) => control.destroy());
            this.showImage();
        };
        this.allControls = [];
        this.videoKey2 = this.getText('End', 'videoKey2');
        this.preTarget2 = () => this.scene.start('End');
        this.postTarget2 = () => {
            this.showPopup();
        };

        this.isPlaying = false;
        this.isDraging = false;
        this.isPaused = false;
    }

    update() {
        super.update();
    }

    create() {
        this.cameras.main.setBackgroundColor(Colors.Elmt.PaleWhite);

        this.showVideo(this.videoKey);
        console.log('this.videoKey', this.videoKey);
    }

    showImage() {
        this.back = this.add.image(this.width / 2, this.height / 2, 'endBackground').setScale(1.5);

        this.cartouche = this.add.existing(
            new WhiteRoundedRectangle(
                this,
                this.width / 2 - (350 * this.scaleX) / 2,
                this.height / 2 - (91 * this.scaleY) / 2,
                350 * this.scaleX,
                91 * this.scaleY,
                this.getText('End', 'firstText'),
                false
            )
        );
        this.nextButton = new ButtonRounded(
            this,
            458 * this.scaleX + 86,
            this.cameras.main.height - 32 - 32,
            86 * 2,
            32 * 2,
            this.getText('End', 'buttonLabel'),
            Colors.Text.DarkBlue,
            Colors.Elmt.White,
            false,
            Colors.Text.White,
            true,
            false,
            'arrow-right',
            null
        );
        this.nextButton.on('pointerdown', () => {
            this.back.destroy();
            this.cartouche.destroy();
            this.preTarget = () => this.scene.start('End');
            this.postTarget = () => {
                this.showPopup();
            };
            this.videoKey2 = this.getText('End', 'videoKey2');

            this.showVideo(this.videoKey2);

            this.events.on('videoComplete', () => {
                this.showPopup();
            });
        });
    }

    /*   showVideo2() {
    this.isDraging = false;
    this.isPlaying = false;
    this.isPaused = false;
    this.barWidth = 392 * this.scaleX;
    this.barY = 272 * this.scaleY + 32;
    this.barX = 88 * this.scaleX;
    console.log("this.scaleX", this.scaleX);
    console.log("this.barWidth", this.barWidth);
    const blocker = this.add.rectangle(
      this.width / 2,
      this.height / 2,
      this.width,
      this.height,
      Colors.Elmt.Black
    );

    // 📹 1. Ajoute la vidéo
    this.video = this.add
      .video(0, 0, this.videoKey2)
      .setOrigin(0.5)
      .setDepth(1);

    // 2. On centre la vidéo au milieu du canvas
    this.video.setPosition(this.width / 2, this.height / 2);
    this.video.setScale(1);
    this.video.setPosition(this.width / 2, this.height / 2);
    this.video.setPaused(true);

    // ▶️ 3. Bouton Play au centre
    this.startButton = this.add
      .image(this.width / 2, this.height / 2, "video-start")
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true })
      .setDepth(3);
    this.startButton.setAlpha(1);
    this.allControls.push(this.startButton);

    // 🕹️ Animation au survol du bouton Play
    this.startButton.on("pointerover", () => {
      this.tweens.add({
        targets: this.startButton,
        scale: 1.1,
        duration: 200,
        ease: "Sine.easeInOut",
      });
    });

    this.startButton.on("pointerout", () => {
      this.tweens.add({
        targets: this.startButton,
        scale: 1,
        duration: 200,
        ease: "Sine.easeInOut",
      });
    });

    // Clique sur le bouton Play pour démarrer la vidéo
    this.startButton.on("pointerdown", () => {
      this.video.play();
      this.isPlaying = true;
      this.video.setMute(false);
      this.video.setVolume(1); // au cas où
      this.startButton.setAlpha(0); // Cache le bouton play
      this.allControls.forEach((control) => control.setVisible(true));
    });

    // ⏱️ Texte durée
    this.currentTimeText = this.add
      .text(473 * this.scaleX - 65, 273 * this.scaleY - 20, "0:00", {
        fontSize: Sizes.Text.p,
        color: "#fff",
        fontFamily: "Monteserrat",
      })
      .setOrigin(0.5)
      .setDepth(20)
      .setVisible(false);
    this.allControls.push(this.currentTimeText);

    this.barretime = this.add
      .text(473 * this.scaleX - 30, 273 * this.scaleY - 20, "/", {
        fontSize: Sizes.Text.p,
        color: "#fff",
        fontFamily: "Monteserrat",
      })
      .setOrigin(0.5)
      .setDepth(20)
      .setVisible(false);
    this.allControls.push(this.barretime);

    this.durationText = this.add
      .text(473 * this.scaleX, 273 * this.scaleY - 20, "0:00", {
        fontSize: Sizes.Text.p,
        color: "#fff",
        fontFamily: "Monteserrat",
      })
      .setOrigin(0.5)
      .setDepth(20)
      .setVisible(false);
    this.allControls.push(this.durationText);

    this.sliderLine = this.add
      .rexRoundRectangle(
        this.width / 2,
        this.barY,
        this.barWidth,
        8,
        4,
        Colors.Elmt.White
      )
      .setAlpha(0.5)
      .setDepth(20)
      .setVisible(false);
    this.allControls.push(this.sliderLine);
    this.barFill = this.add
      .rexRoundRectangle(this.barX, this.barY, 0, 8, 4, Colors.Elmt.White)
      .setOrigin(0, 0.5)
      .setDepth(20)
      .setVisible(false);
    this.allControls.push(this.barFill);
    this.sliderLine.setSize(this.barWidth, this.sliderLine.height);
    this.sliderLine.setInteractive({ useHandCursor: true });
    this.sliderLine.on("pointerdown", (event) => {
      let a = event.x;
      let b = this.sliderLine.x;
      let c = a - b;
      let value = (c + this.barWidth / 2) / this.barWidth;
      this.barFill.width = value * this.barWidth;
      this.slider.value = value;
      this.video.seekTo(value);
    });
    this.sliderButton = this.add
      .circle(
        this.width / 2 - this.barWidth / 2,
        this.barY,
        30,
        Colors.Elmt.White
      )
      .setInteractive({ useHandCursor: true })
      .setAlpha(1)
      .setDepth(20)
      .setVisible(false);
    this.allControls.push(this.sliderButton);
    this.sliderButton.setStrokeStyle(4, Colors.Elmt.White);
    this.sliderButton.on("pointerdown", () => {
      this.isDraging = true;
      this.isPlaying = false;
      this.video.setPaused(true);
    });
    this.sliderButton.on("pointerup", () => {
      this.isDraging = false;
      if (this.video.isPaused()) {
        this.isPlaying = false;
        this.video.setPaused(true);
      } else {
        this.isPlaying = true;
        this.video.setPaused(false);
      }
    });

    this.input.on("pointerup", () => {
      if (this.isDraging) {
        this.isDraging = false;
        this.isPlaying = true;
        this.video.setPaused(false);
      }
    });

    this.slider = this.plugins.get("rexSlider").add(this.sliderButton, {
      endPoints: [
        { x: this.sliderLine.x - this.barWidth / 2, y: this.sliderLine.y },
        { x: this.sliderLine.x + this.barWidth / 2, y: this.sliderLine.y },
      ],
      value: 0,
      enable: true,
      valuechangeCallback: (value) => {
        if (this.isDraging) {
          this.video.seekTo(value);
        }
      },
    });

    // 📥 Sur fin de la vidéo
    let hasEnded = false;

    this.video.on("complete", () => {
      hasEnded = true;
      this.postTarget2(this);
    });

    // Clique sur la vidéo pour la mettre en pause ou reprendre
    this.video.setInteractive();
    this.video.on("pointerdown", () => {
      if (hasEnded) return;
      // Si la vidéo est en pause, la reprendre
      if (this.video.isPaused()) {
        this.video.resume();
        this.startButton.setAlpha(0); // Cacher le bouton Play
      } else {
        // Sinon, mettre la vidéo en pause
        this.video.pause();
        this.startButton.setAlpha(1); // Montrer le bouton Play
      }
    });

    this.buttonReculer = this.add
      .image(32 + 32, this.height - 32 - 32, "video-reculer")
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        this.preTarget2(this);
      })
      .setVisible(false)
      .setDepth(20);
    this.allControls.push(this.buttonReculer);

    this.buttonAvancer = this.add
      .image(this.width - 32 - 32, this.height - 32 - 32, "video-avancer")
      .setOrigin(0.5)
      .setInteractive({ useHandCursor: true })
      .on("pointerdown", () => {
        this.postTarget2(this);
      })
      .setVisible(false)
      .setDepth(20);
    this.allControls.push(this.buttonAvancer);
  } */

    showPopup() {
        this.cart = this.add.existing(
            new WhiteRoundedRectangle(
                this,
                this.width / 2 - (300 * this.scaleX) / 2,
                this.height / 2 - (127 * this.scaleY) / 2,
                300 * this.scaleX,
                127 * this.scaleY,
                this.getText('End', 'secondText'),
                true,
                this.getText('End', 'buttonLabel2'),
                true,
                this.getText('End', 'secondTitre')
            )
        );

        this.cart.btn.on('pointerdown', () => {
            this.cart.destroy();
            if (this.game.data.lang === 'fr') {
                this.scene.start('Karaoke');
            } else {
                this.scene.start('Credits');
            }
        });
    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }
}
